// src/contexts/ContextManager.tsx
import React from "react";
import {UserProvider} from "./UserContext";
import {InfoBoxProvider} from "@/commons/infoBox/InfoBox";
import {CookiesProvider} from "@/contexts/CookiesContext";

const ContextManager: React.FC<{children: React.ReactNode}> = ({children}) => {
    return (
        <InfoBoxProvider>
            <UserProvider>
                <CookiesProvider>
                {children}
                </CookiesProvider>
            </UserProvider>
        </InfoBoxProvider>
    );
};

export default ContextManager;
